import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx-js-style';
import { ExcelData, ExcelOptions, ExcelTemplate, ExcelTemplateName } from './interfaces';
import { FundStrategyInternalTemplate } from './templates/fund-strategy/internal/fundStrategyInternalTemplate';
import { FundStrategyExternalTemplate } from './templates/fund-strategy/external/fundStrategyExternalTemplate';

/**
 * Service for work with Excel sheets.
 * If you have any questions ask Yan plz.
 * This is really tough shit.
 *
 * If you want to use this service with your own template please
 * check the template in the 'templates' folder.
 */
@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  private templates: { [k in ExcelTemplateName]: ExcelTemplate } = {
    [ExcelTemplateName.fundStrategyInternal]: new FundStrategyInternalTemplate(),
    [ExcelTemplateName.fundStrategyExternal]: new FundStrategyExternalTemplate(),
  };

  /**
   * Export data to excel file by template.
   *
   * @param data Data to export.
   * @param fileName File name to export.
   * @param options Options for template.
   * @param templateName Template name.
   */
  exportByTemplate(
    data: ExcelData,
    fileName: string,
    templateName: ExcelTemplateName,
    options: ExcelOptions = {},
  ): void {
    const template = this.templates[templateName];
    const book = template.export(data, options);
    XLSX.writeFile(book, fileName);
  }
}
